import { Cookies } from "@/constants/cookies"
import { cookieService } from "@/services/cookie-service"

export const VOICE_INTERNAL_DATA_CONSENT_VERSION = "v2" as const

/** Legacy `hideVoiceModeInfo=true` is intentionally not accepted as consent. */
export function isVoiceInternalDataConsentGranted(value: string | undefined): boolean {
  return value === VOICE_INTERNAL_DATA_CONSENT_VERSION
}

export function hasVoiceInternalDataConsent(): boolean {
  return isVoiceInternalDataConsentGranted(cookieService.get(Cookies.voiceInternalDataConsent.key))
}

export function grantVoiceInternalDataConsent(): void {
  cookieService.set(Cookies.voiceInternalDataConsent.key, VOICE_INTERNAL_DATA_CONSENT_VERSION)
  // Remove the ambiguous legacy preference after an explicit V2 decision.
  cookieService.remove(Cookies.hideVoiceModeInfo.key)
}
